import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["router", "action", "actionKey", "queryVariables", "parentComponent", "userPropsToDisplay", "handleOnSuccess"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useQuery } from '@apollo/client';
import { checkIfLoggedIn } from '@blaze-cms/core-auth-ui';
import { getUser } from '@blaze-cms/react-page-builder';
import { withRouter } from 'next/router';
import GTMEvent from './GTMEvent';
import { buildDataLayer, buildNestedEvent, buildUserQueryProps, buildUserLayer } from '../helpers';
const GTMEventRender = _ref => {
  let {
      router,
      action,
      actionKey,
      queryVariables,
      parentComponent,
      userPropsToDisplay,
      handleOnSuccess
    } = _ref,
    eventProps = _objectWithoutProperties(_ref, _excluded);
  const {
    asPath
  } = router;
  const [currentLocation, setCurrentLocation] = useState('');
  const {
    data = {},
    error,
    loading
  } = useQuery(action, queryVariables);
  const {
    id: userId
  } = checkIfLoggedIn();
  const hasUserProps = userId && userPropsToDisplay && userPropsToDisplay.length;
  const userProps = hasUserProps ? buildUserQueryProps(userPropsToDisplay) : '';
  const {
    data: userData,
    loading: userLoading
  } = useQuery(getUser(userProps), {
    variables: {
      id: userId
    },
    skip: !hasUserProps
  });
  if (loading || userLoading || error) return null;
  const gtmData = data.entityData || data[actionKey];
  if (currentLocation !== asPath) {
    setCurrentLocation(asPath);
    return null;
  }
  const {
    eventTrigger,
    propsToDisplay,
    eventEcommerce
  } = eventProps;
  const dataLayerProps = buildDataLayer(gtmData, propsToDisplay);
  const dataLayerObject = buildNestedEvent(eventEcommerce, eventProps, dataLayerProps, parentComponent);
  const userLayerObject = buildUserLayer(userData, userPropsToDisplay);
  const extendedDataLayer = _objectSpread(_objectSpread({}, dataLayerObject), userLayerObject);
  return /*#__PURE__*/React.createElement(GTMEvent, {
    dataLayerObject: extendedDataLayer,
    eventTrigger: eventTrigger,
    currentLocation: currentLocation,
    handleOnSuccess: handleOnSuccess
  });
};
GTMEventRender.propTypes = {
  userPropsToDisplay: PropTypes.array,
  router: PropTypes.object.isRequired,
  action: PropTypes.object.isRequired,
  actionKey: PropTypes.string.isRequired,
  queryVariables: PropTypes.object.isRequired,
  parentComponent: PropTypes.object.isRequired,
  handleOnSuccess: PropTypes.func
};
GTMEventRender.defaultProps = {
  userPropsToDisplay: [],
  handleOnSuccess: () => {}
};
GTMEventRender.defaultProps = {
  userPropsToDisplay: []
};
export default withRouter(GTMEventRender);
//# sourceMappingURL=GTMEventRender.js.map